import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { customerSchemaToAddApplicant } from '~/components/organisms/CustomerForm/utils/formHelper.ts';
import { customerFormEventsName } from '~/components/organisms/CustomerForm/constant.ts';
import {
  CustomerFormEventType,
  CustomerSaveContext,
  CustomerSchema,
} from '~/components/organisms/CustomerForm/CustomerFormProvider.tsx';
import { FormMode } from '~/components/molecules/index.ts';

export interface UseCustomerFormReturn {
  submit: () => void;
  track?: (event: CustomerFormEventType) => void;
  close: () => void;
  formMode: FormMode | undefined;
  setFormMode: (mode: FormMode) => void;
}

export function useCustomerForm(): UseCustomerFormReturn {
  const { handleSubmit, formState } = useFormContext<CustomerSchema>();
  const {
    onSubmit,
    onTrack: track,
    onClose,
    setShowUnsavedDialog,
    formMode,
    setFormMode,
  } = useContext(CustomerSaveContext);

  const submit = (currentCustomer: CustomerSchema): void => {
    const updatedDeal = customerSchemaToAddApplicant(currentCustomer);
    if (onSubmit) {
      onSubmit(updatedDeal);
    }
    track?.(customerFormEventsName.ADD_CUSTOMER_DETAILS_FINISH);
  };

  const { isDirty } = formState;

  const handleClose = (): void => {
    if (isDirty) {
      setShowUnsavedDialog(true);
    } else {
      onClose();
    }
  };
  return {
    submit: () => handleSubmit(submit)(),
    close: handleClose,
    track,
    formMode,
    setFormMode,
  };
}
